/**
 * OFCS interface object
 *
 * Implements a interface like pattern in javascript
 *
 * @constructor
 */
export default class Interface {
    constructor(definition) {
        this.definition = definition;
    }

    /**
     * Check if the interface is implemented or throw error
     *
     * @param {*} obj
     * @return {boolean}
     * @throws Error
     */
    assert(obj) {
        Object.keys(this.definition).forEach((key) => {
            const prop = this.definition[key];

            if (obj[key] === undefined) {
                throw new Error(`Missing property "${key}"`);
            } else if (typeof prop !== typeof obj[key]) {
                throw new Error(`Property "${key}" is type of ${typeof obj[key]}, but ${typeof prop} was expected`);
            }
        });

        return true;
    }

    /**
     * Check if the interface is implemented and return a boolean accordingly
     *
     * @param {*} obj
     * @return {boolean}
     */
    isImplementedBy(obj) {
        try {
            this.assert(obj);
        } catch (e) {
            return false;
        }

        return true;
    }
}
